import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
  },
  {
    path: '/reduce-ai',
    name: 'ReduceAI',
    component: () => import('@/views/ReduceAI.vue'),
  },
  {
    path: '/check-ai',
    name: 'CheckAI',
    component: () => import('@/views/CheckAI.vue'),
  },
  {
    path: '/recharge',
    name: 'Recharge',
    component: () => import('@/views/Recharge.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue'),
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/ForgotPassword.vue'),
  },
  {
    path: '/profile',
    name: 'UserProfile',
    component: () => import('@/views/UserProfile.vue'),
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: () => import('@/views/ChangePassword.vue'),
  },
  {
    path: '/invite-reward',
    name: 'InviteReward',
    component: () => import('@/views/InviteReward.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router

